export const TimeEntryTypeConst = {
  ENTRADA: 1,
  SAIDA: 2,
  INICIO_INTERVALO: 3,
  FIM_INTERVALO: 4,
};

export const TimeEntryTypeLabel: Record<number, string> = {
  [TimeEntryTypeConst.ENTRADA]: "Entrada",
  [TimeEntryTypeConst.SAIDA]: "Saída",
  [TimeEntryTypeConst.INICIO_INTERVALO]: "Início de Intervalo",
  [TimeEntryTypeConst.FIM_INTERVALO]: "Fim de Intervalo",
};
